import React, { Fragment, useEffect, useState, useRef } from 'react';
import { Button, Col, Container, Form, Image, Row } from 'react-bootstrap';
import { Turnstile } from '@marsidev/react-turnstile';
import { useForm } from "react-hook-form";
import axios from 'axios';
import { toast } from 'react-toastify';
import ReactGA from 'react-ga4';
import { useParams } from 'react-router-dom';

const messages = {
    1: '¡Hola! Me gustaría saber más de la ceremonia elemental.',
    2: '¡Hola! Me gustaría saber más de la ceremonia éter.',
};

const ContactPage = () => {
    useEffect(() => {
        ReactGA.send({ hitType: "pageview", page: window.location.pathname, title: "Contacto" });
    }, []);

    const messageId = useParams().id;
    const [message, setMessage] = useState('');
    const [isSending, setIsSending] = useState(false);
    const [turnstileToken, setTurnstileToken] = useState('');

    const turnstileRef = useRef(null);
    const { register, handleSubmit, reset, formState: { errors } } = useForm();
    const opcionesToast = {
        position: toast.POSITION.TOP_CENTER,
        theme: "colored"
    };

    const continueOnSubmit = (formData, tokenCaptcha) => {
        const payload = {
            nombre: formData.nombre?.trim(),
            email: formData.email?.trim(),
            mensaje: formData.mensaje?.trim(),
            website: formData.website || '',
            token: tokenCaptcha
        };

        axios({
            url: "/api/contact.php",
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            headers: {
                'Content-Type': 'application/json'
            },
            data: payload
        })
            .then((resp) => {
                toast.success(resp.data.message || 'Mensaje enviado correctamente.', opcionesToast);
                reset();
                setTurnstileToken('');
            })
            .catch((error) => {
                const errorMsg = error.response?.data?.message || error.response?.data?.error || error.message || 'Ocurrió un error. Intente nuevamente.';
                toast.error(errorMsg, opcionesToast);
            })
            .finally(() => {
                setIsSending(false);
                turnstileRef.current?.reset();
            });
    };

    useEffect(() => {
        if (messageId && messages[messageId]) {
            setMessage(messages[messageId]);
        }
    }, [messageId]);

    const onSubmit = (data) => {
        const token = turnstileToken || turnstileRef.current?.getResponse();
        if (!token) {
            toast.error('Por favor, completa la verificación de seguridad.', opcionesToast);
            return;
        }

        setIsSending(true);
        continueOnSubmit(data, token);
    };

    return (
        <Fragment>
            <div className="section-title position-relative text-center mx-auto mb-5 mt-5 pb-3" style={{ maxWidth: '600px' }}>
                <h1 className="display-4 text-uppercase font-title">Contacto</h1>
            </div>
            <Container fluid={true} className="py-1 mb-5">
                <Container className="py-1">
                    <Row className='justify-content-start'>
                        <Col md={5} className=''>
                            <Image src={process.env.PUBLIC_URL + '/imgs/equipo/contacto_elemental_ancho.jpg'} style={{ objectFit: 'cover' }} fluid alt="Contacto Elemental Ceremonias" />
                        </Col>
                        <Col md={7} className='text-primary-2 align-items-center'>
                            <Form onSubmit={handleSubmit(onSubmit)}>
                                {/* Campo trampa Honeypot para detectar bots */}
                                <div style={{ position: 'absolute', left: '-9999px', opacity: 0, height: 0, width: 0, overflow: 'hidden' }} aria-hidden="true">
                                    <input
                                        type="text"
                                        tabIndex="-1"
                                        autoComplete="off"
                                        {...register("website")}
                                    />
                                </div>

                                <Form.Group className="mb-3">
                                    <Form.Label>Nombre</Form.Label>
                                    <Form.Control className='text-primary-2' type="text" {...register("nombre", { required: true, minLength: 3, maxLength: 50 })} placeholder="Ingrese su nombre y apellido" />
                                    {errors.nombre && <span className='text-error'>(*) Campo requerido (mínimo 3 caracteres y máximo 50)</span>}
                                </Form.Group>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control className='text-primary-2' type="email" placeholder="Ingrese el email" {...register("email", { required: true, minLength: 3, maxLength: 100 })} />
                                    {errors.email && <span className='text-error'>(*) Campo requerido (mínimo 3 caracteres y máximo 100)</span>}
                                </Form.Group>

                                <Form.Group className="mb-3" >
                                    <Form.Label>Mensaje</Form.Label>
                                    <Form.Control defaultValue={message} className='text-primary-2' as="textarea" placeholder="Mensaje" {...register("mensaje", { required: true, minLength: 20, maxLength: 1000 })} />
                                    {errors.mensaje && <span className='text-error'>(*) Campo requerido (mínimo 20 caracteres y máximo 1000)</span>}
                                </Form.Group>

                                <div className="mb-3">
                                    <Turnstile
                                        ref={turnstileRef}
                                        siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY || "0x4AAAAAAEkKQrlJ_fzkzjVa"}
                                        onSuccess={(token) => setTurnstileToken(token)}
                                        onExpire={() => setTurnstileToken('')}
                                        onError={() => setTurnstileToken('')}
                                        options={{
                                            theme: 'light',
                                            size: 'normal'
                                        }}
                                    />
                                </div>

                                <Button variant="primary" type="submit" disabled={isSending}>
                                    <i className="bi bi-send"></i> {isSending ? 'Enviando...' : 'Enviar'}
                                </Button>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </Fragment>
    );
};

export default ContactPage;